import {useLazyQuery} from '@apollo/client';
import {boardViewQueries} from 'api/graphql-queries';
import {BoardViewResponse, BoardViewRequest, BoardView} from 'models/board';
import {useDispatch, useSelector} from 'react-redux';
import {useCallback, useEffect, useMemo} from 'react';
import {boardSelector, setBoardViews, setSelectedBoardView} from 'store/boards/boardSlice';

export const useBoardViewInRedux = () => {
    const {boardViewsRedux, selectedBoardViewRedux} = useSelector(boardSelector);
    const dispatch = useDispatch();

    const boardViews = useMemo(() => {
        return boardViewsRedux;
    }, [boardViewsRedux]);

    const selectedBoardView = useMemo(() => {
        return selectedBoardViewRedux;
    }, [selectedBoardViewRedux]);

    const setBoardViewsinRedux = useCallback(
        (boardViews: BoardView[]) => {
            dispatch(setBoardViews(boardViews));
        },
        [dispatch],
    );

    const setSelectedBoardViewInRedux = useCallback(
        (boardView: BoardView) => {
            dispatch(setSelectedBoardView(boardView));
        },
        [dispatch],
    );

    return {
        boardViews,
        selectedBoardView,
        setBoardViewsinRedux,
        setSelectedBoardViewInRedux,
    };
};

export const useGetAllBoardViews = () => {
    const {setBoardViewsinRedux, setSelectedBoardViewInRedux} = useBoardViewInRedux();
    const [refetch, {loading, data}] = useLazyQuery<BoardViewResponse, BoardViewRequest>(
        boardViewQueries.GET_BOARD_VIEWS_BY_BOARD_ID,
        {
            fetchPolicy: 'no-cache', // Doesn't check cache before making a network request
        },
    );
    useEffect(() => {
        if (data && data.boardViews) {
            setBoardViewsinRedux(data.boardViews.nodes);
            setSelectedBoardViewInRedux(data.boardViews.nodes[0]);
        }
    }, [data]);

    return {
        getAllBoardViewsByBoardId: refetch,
        getAllBoardViewsByBoardResponse: data?.boardViews.nodes,
        getAllBoardViewsByBoardIdLoading: loading,
    };
};
